import CloseIcon from "@mui/icons-material/Close";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicTable from "../../components/Comman/RT/MaterialUIRTTable";
import { LabelCompo } from "../../components/Comman/Label";
import { lightVioletColor, redColor, smoothGreenColor, titleColor, yellowColor } from "../../config/ColorObj";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import NoDataFound from "../DashbourdChanges/NoDataFound";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const TimeSlotOtherTaskPopUpRMDashboard = ({
    taskName,
    otherTaskIdForTimeSlot,
    handleCloses,
    open,
    columns,
    rows,
}) => {

    const handleClose = () => {
        handleCloses();
    };



    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth={otherTaskIdForTimeSlot == 1 || otherTaskIdForTimeSlot == 2 ? "lg" : "md"}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Task
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <DynamicDetails
                        DataToSet={[{
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Task Name ",
                            value: taskName ? taskName : "-",
                        },]}
                    />
                    {otherTaskIdForTimeSlot == 1 || otherTaskIdForTimeSlot == 2 ? (
                        <DynamicTable
                            data={rows}
                            tableHead={columns}
                            showPegination={false}
                            isActionColActive={false}
                        />
                    ) : otherTaskIdForTimeSlot == 4 || otherTaskIdForTimeSlot == 3 ? (
                        <TableContainer style={{ overflow: 'auto' }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" width="5%">
                                            Sr. No.
                                        </TableCell>
                                        <TableCell align="center" width="12%">
                                            Name
                                        </TableCell>
                                        <TableCell align="center" width="12%">
                                            Address
                                        </TableCell>
                                        <TableCell align="center" width="12%">
                                            Remark
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.length !== 0 ? (
                                        <>
                                            {
                                                rows.map((row, index) => (
                                                    <TableRow key={row.id}>
                                                        <TableCell align="center">{index + 1}</TableCell>
                                                        <TableCell align="left">{row.salesTeamPersonName}</TableCell>
                                                        <TableCell align="left">{row.salesTeamPersonAddress}</TableCell>
                                                        <TableCell style={{ whiteSpace: "pre-line" }} align="left">{row.description}</TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </>
                                    ) : (<TableRow>
                                        <TableCell colSpan={7} align="center">
                                            <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                No data found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>)}


                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : otherTaskIdForTimeSlot == 6 ? (
                        <TableContainer style={{ overflow: 'auto' }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" width="5%">
                                            Sr. No.
                                        </TableCell>
                                        <TableCell align="center" width="12%">
                                            Name
                                        </TableCell>
                                        <TableCell align="center" width="12%">
                                            Address
                                        </TableCell>
                                        <TableCell align="center" width="12%">
                                            Work With
                                        </TableCell>
                                        <TableCell align="center" width="12%">
                                            Remark
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.length !== 0 ? (
                                        <>
                                            {rows.map((row, index) => (
                                                <TableRow key={row.id}>
                                                    <TableCell align="center">{index + 1}</TableCell>
                                                    <TableCell align="left">{row.salesTeamPersonName}</TableCell>
                                                    <TableCell align="left">{row.salesTeamPersonAddress}</TableCell>
                                                    <TableCell align="left">{row.entityName}</TableCell>
                                                    <TableCell style={{ whiteSpace: "pre-line" }} align="left">{row.description}</TableCell>
                                                </TableRow>
                                            ))}
                                        </>
                                    ) : (<TableRow>
                                        <TableCell colSpan={7} align="center">
                                            <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                No data found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>) : ([])}
                    <br />
                </DialogContent>
            </BootstrapDialog >
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TimeSlotOtherTaskPopUpRMDashboard);


const workStyle = (itemObject) => ({
    fontSize: "12px",
    fontWeight: "450",
    borderRadius: "6px",
    padding: "6px",
    minHeight: "27px",
    backgroundColor:
        itemObject.otherTaskId == 1 && itemObject.workingTypeId != 5
            ? LightGreenColor // retailing
            : itemObject.otherTaskId == 2 && itemObject.workingTypeId != 5
                ? titleColor // distributor
                : itemObject.otherTaskId == 3
                    ? lightVioletColor // officeWorkColor
                    : itemObject.otherTaskId == 4
                        ? yellowColor
                        : smoothGreenColor, //other work
});